import {Component, OnInit} from '@angular/core';
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Shipment} from "../services/shipment";
import {ShipmentsService} from "../services/shipments.service";
import {ShipmentRoutesService} from "../services/shipment-routes.service";
import {ShipmentProductLine} from "../services/shipment-product-line";

@Component({
    selector: 'app-shipment-event-modal',
    templateUrl: './shipment-event-modal.component.html',
    styleUrls: ['./shipment-event-modal.component.scss'],
    providers: [ShipmentRoutesService]
})

export class ShipmentProductLineModalComponent implements OnInit {

    modal: NgbModalRef;
    shipment: Shipment;
    shipment_product_line: ShipmentProductLine;

    protected possibleDgClasses: string[] = [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9'
    ];

    protected possiblepackaging_groups: string[] = [
        'I',
        'II',
        'III'
    ];

    protected possiblePackagings: string[] = [
        'Ståltromle med ikke-aftageligt låg',
        'Ståltromle med ikke-aftageligt låg - special',
        'Ståltromle med aftageligt låg',
        'Tromle af stål, aftageligt låg, bjærgningsemballage',
        'Ståltromle med aftageligt låg - special (fyldes og svejses hos kunden)',
        'Aluminiumtromle med ikke-aftageligt låg',
        'Aluminiumtromle med aftageligt låg',
        'Krydsfinertromle',
        'Fibertromle med aftageligt låg',
        'Plasttromle med ikke-aftageligt låge',
        'Plastspand med aftageligt låg (kun til faste stoffer)',
        'Tromle af metal, bortset fra stål og aluminium, med ikke-aftageligt låg',
        'Tromle af metal, bortset fra stål og aluminium, med aftageligt låg',
        'Trætønde med spuns',
        'Trætønde med aftageligt låg',
        'Ståldunk med med ikke-aftageligt låg',
        'Ståldunk med med aftageligt låg',
        'Aluminiumdunk med med ikke-aftageligt låg',
        'Aluminiumdunk med med aftageligt låg',
        'Plastdunk med med ikke-aftageligt låg',
        'Plastdunk med med aftageligt låg',
        'Stålkasse',
        'Aluminiumkasse',
        'Naturtrækasse almindelig',
        'Naturtrækasse støvtæt',
        'Krydsfinérkasse',
        'Fiber- og spånpladekasse o.l.',
        'Papkasse',
        'Papkasse prøvet med skrøbelige inderemballager',
        'Papkasse - special (aftageligt låg)',
        'Plastkasse - skumplast',
        'Plastkasse - homogent plast',
        'Plastkasse prøvet med skrøbelige inderemballager',
        'Storemballage - stål',
        'Storemballage - aluminium',
        'Storemballage - naturtræ',
        'Storemballage - krydsfiner',
        'Storemballage - fiberplade, spånplade og lign.',
        'Storemballage - stift pap',
        'Storemballage - stift pap med afvigende design',
        'Storemballage - stiv plast',
        'Storemballage - metal (bortset fra stål og aluminium)',
        'Storemballage - fleksibel plast',
        'Storemballage - fleksibelt papir',
        'Vævet plastsæk, uden foring eller indv. belægning',
        'Vævet plastsæk, støvtætte',
        'Vævet plastsæk, vandfaste',
        'Sække af plastfolie/-film',
        'Tekstilsække, uden foring eller indv. belægning',
        'Tekstilsække, støvtætte',
        'Tekstilsække, vandfaste',
        'Papirsæk, flerlags',
        'Papirsæk, flerlags, vandfast',
        'Plastbeholder i ståltromle',
        'Plastbeholder i tremmekasse eller anden kasse af stål',
        'Plastbeholder i tremmekasse eller anden kasse af aluminium',
        'Plastbeholder i aluminiumstromle',
        'Plastbeholder i trækasse',
        'Plastbeholder i krydsfinertromle',
        'Plastbeholder i krydsfinerkasse',
        'Plastbeholder i paptromle',
        'Plastbeholder i papkasse',
        'Plastbeholder i plasttromle',
        'Plastbeholder i kasse af massiv plast',
        'Beholder af glas, porcelæn eller stentøj i ståltromle',
        'Beholder af glas, porcelæn eller stentøj i tremmekasse eller anden kasse af stål',
        'Beholder af glas, porcelæn eller stentøj i aluminiumstromle',
        'Beholder af glas, porcelæn eller stentøj i tremmekasse eller anden kasse af aluminium',
        'Beholder af glas, porcelæn eller stentøj i trækasse',
        'Beholder af glas, porcelæn eller stentøj i krydsfinertromle',
        'Beholder af glas, porcelæn eller stentøj i vidjekurv',
        'Beholder af glas, porcelæn eller stentøj i paptromle',
        'Beholder af glas, porcelæn eller stentøj i papkasse',
        'Beholder af glas, porcelæn eller stentøj i skumplastemballage',
        'Beholder af glas, porcelæn eller stentøj i homogen plastemballage',
        'Spraydåse',
        'Tube',
        'Patron'
    ].sort((a,b) => {
        return a.localeCompare(b);
    });

    protected disableAmount: string | false | true;

    constructor(
        public shipmentsService: ShipmentsService,
    ) {
    }

    ngOnInit() {
        const notaNumberString = this.shipment.nota_number?.toString() ?? '';
        const hasLetterOnlySixCharNotaNumber = /^[a-zA-Z]{6}$/.test(notaNumberString);

        this.disableAmount = !(
            this.shipment.is_internal_shipment ||
            !this.shipment_product_line.id ||
            hasLetterOnlySixCharNotaNumber
        );
    }

    save() {
        this.shipmentsService.updateShipment(this.shipment).then(result => {
            this.modal.close(true);
        })
    }

    close() {
        this.modal.close();
    }

    onWeightChange(value: any) {
        const str = String(value ?? '');
        const sanitized = str.replace(/,/g, '.').replace(/^\-+/, '');
        const num = sanitized === '' ? null : Number(sanitized);
        this.shipment_product_line.weight = Number.isFinite(num as number) ? num : null;
    }
}
